import { render, staticRenderFns } from "./OrdersByProduct.vue?vue&type=template&id=03b593b8&scoped=true"
import script from "./OrdersByProduct.vue?vue&type=script&lang=js"
export * from "./OrdersByProduct.vue?vue&type=script&lang=js"
import style0 from "./OrdersByProduct.vue?vue&type=style&index=0&id=03b593b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03b593b8",
  null
  
)

export default component.exports